module.exports = __webpack_public_path__ + "static/ValidatedBadge-a70dbe12138d798649547854266ff684.svg";